/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_In_Transit_HintInputs */

const en_metric_in_transit_hint = /** @type {(inputs: Metric_In_Transit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currently shipping`)
};

const es_metric_in_transit_hint = /** @type {(inputs: Metric_In_Transit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En envio actualmente`)
};

/**
* | output |
* | --- |
* | "Currently shipping" |
*
* @param {Metric_In_Transit_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const metric_in_transit_hint = /** @type {((inputs?: Metric_In_Transit_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_In_Transit_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_metric_in_transit_hint(inputs)
	return es_metric_in_transit_hint(inputs)
});